import classes from './SaveUnfinishedButton.module.css';
import { useTranslation } from 'react-i18next';

interface ButtonProps {
    formSubmitHandler: (e: React.SyntheticEvent<HTMLFormElement> | undefined, step: string, unfinished?: string | undefined) => void,
    step: string
}

const SaveUnfinishedButton = (
    {
        formSubmitHandler,
        step
    }: ButtonProps
) => {
    // Set translation
    const { t } = useTranslation();

    // Function that handles "save unfinished" button
    const handleSaveUnfinished = () => {
        // Do save
        formSubmitHandler(undefined, step, "unfinished");
    };

    return (
        <div
            className={classes.saveUnfinishedButton}
            onClick={() => handleSaveUnfinished()}
        >
            {t("saveUnfinishedButton.text")}
        </div>
    )
};

export default SaveUnfinishedButton;